import React from 'react'
import { Link } from 'react-router-dom'
import Modal from 'components/Modal/Modal'

const SubscriptionDialog = ({ t, isOpen, onClose }) => {
	return (
		<Modal
			title={t("home.warning")}
			visible={isOpen}
			onClose={onClose}
			content={
				<p>
				{t("home.overPlan")} (
				<Link className='Polaris-Link' to='/subscription'>
					{t("home.selectPlan")}
				</Link>
			){t("home.dot")}
			<br />
			{t("home.canCont")}
			{t("home.dot")}
				</p>
			}
		/>
	)
}

export default SubscriptionDialog

